import React, { useState, useEffect } from 'react';

const FAQTab = () => {
    const [faqs, setFaqs] = useState([]);
    const [form, setForm] = useState({ id: null, question: '', answer: '' });
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        fetchFaqs();
    }, []);

    const fetchFaqs = async () => {
        const res = await fetch('/api/faqs');
        const data = await res.json();
        setFaqs(data);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const url = isEditing 
            ? `/api/faqs/${form.id}`
            : '/api/faqs';
        
        const method = isEditing ? 'PUT' : 'POST';

        const res = await fetch(url, {
            method: method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ question: form.question, answer: form.answer })
        });

        if (res.ok) {
            fetchFaqs();
            resetForm();
        }
    };

    const handleDelete = async (id) => {
        if(!window.confirm("Delete this FAQ?")) return;
        await fetch(`/api/faqs/${id}`, { method: 'DELETE' });
        fetchFaqs();
    };

    const handleEdit = (faq) => {
        setForm(faq);
        setIsEditing(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const resetForm = () => {
        setForm({ id: null, question: '', answer: '' });
        setIsEditing(false);
    };

    return (
        <div className="space-y-8">
            {/* FORM */}
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-black text-slate-800 uppercase">{isEditing ? 'Edit FAQ' : 'Add New FAQ'}</h3>
                    {isEditing && <button onClick={resetForm} className="text-xs font-bold text-red-500">Cancel Edit</button>}
                </div>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="text-xs font-bold text-slate-400 uppercase">Question</label>
                        <input required value={form.question} onChange={e => setForm({...form, question: e.target.value})} className="w-full p-3 border rounded-xl font-bold" placeholder="e.g. Is it free?" />
                    </div>
                    <div>
                        <label className="text-xs font-bold text-slate-400 uppercase">Answer</label>
                        <textarea required value={form.answer} onChange={e => setForm({...form, answer: e.target.value})} className="w-full p-3 border rounded-xl h-24" placeholder="Answer here..." />
                    </div>
                    <button type="submit" className="bg-slate-900 text-white px-8 py-3 rounded-xl font-bold uppercase text-xs hover:bg-orange-500 transition-colors">
                        {isEditing ? 'Update FAQ' : 'Save FAQ'}
                    </button>
                </form>
            </div>

            {/* LIST */}
            <div className="space-y-4">
                {faqs.map((faq) => (
                    <div key={faq.id} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex justify-between items-start gap-4 group">
                        <div className="flex-1">
                            <h4 className="font-bold text-slate-900 mb-2">{faq.question}</h4>
                            <p className="text-sm text-slate-500">{faq.answer}</p>
                        </div>
                        <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                            <button onClick={() => handleEdit(faq)} className="text-blue-500 font-bold text-xs bg-blue-50 px-3 py-1 rounded-full hover:bg-blue-100">Edit</button>
                            <button onClick={() => handleDelete(faq.id)} className="text-red-500 font-bold text-xs bg-red-50 px-3 py-1 rounded-full hover:bg-red-100">Delete</button>
                        </div>
                    </div>
                ))}
                {faqs.length === 0 && <p className="text-center text-slate-400">No FAQs found.</p>}
            </div>
        </div>
    );
};

export default FAQTab;